import React from 'react';
import { useRouter } from 'next/router';
import sendEvent from '../../helpers/tracking';
import { useMobile } from '../../helpers/hooks';
import icons from '../../shared/assets/icons/redesign';

import './DashboardAdditionalCategoryList.scss';

const { Discount, Community, Insurance, PlayBoardered, ExpertLocation } = icons;

export default function DashboardAdditionalCategoryList({ user }) {
  const router = useRouter();
  const [isMobile] = useMobile();

  const list = [
    {
      Icon: ExpertLocation,
      link: '/deskundigen-in-de-buurt',
      title: 'Deskundigen in jouw buurt',
      tracking: ['dashboard-mobile', 'dashboard-mobile-deskundigen'],
      description:
        'Hier vind je verschillende deskundigen in jouw buurt die je kunnen ondersteunen tijdens je zwangerschap.'
    },
    {
      Icon: Community,
      link: '/community/onboarding?groupXuid=null',
      tracking: ['dashboard-mobile', 'dashboard-mobile-communitygroepen'],
      title: 'Community groepen',
      description:
        'Hier kun je babbelen over bepaalde onderwerpen met gelijk gestemden.'
    },
    {
      Icon: PlayBoardered,
      link: user.hasCourseAccess
        ? '/zwangerschapscursus/overzicht'
        : '/zwangerschapscursus/welkom',
      tracking: ['dashboard-mobile', 'dashboard-mobile-cursussen'],
      title: 'Cursussen',
      description:
        'Hier vind je gratis online cursussen die worden vergoed door je zorgverzekering'
    },
    {
      Icon: Insurance,
      link: '/verzekeringen?dimension4=dashboard_ins',
      tracking: ['dashboard-mobile', 'dashboard-mobile-verzekeringen'],
      title: 'Verzekeringen',
      description: 'Hier helpen we je met een verzekerings-check'
    },
    {
      Icon: Discount,
      link: user.premium ? '/discount-program-categories' : '/voordeel',
      tracking: ['dashboard-mobile', 'dashboard-mobile-collectiviteitskorting'],
      title: 'Collectiviteits korting',
      description:
        'Collectieve korting voor de gebruikers  van zwangerenportaal.nl'
    }
  ];

  return (
    <ul className="dashboardAdditionalCategoryList">
      {list.map(({ Icon, title, description, tracking, link }, idx) => (
        <li
          key={idx}
          className="dashboardAdditionalCategoryList-item"
          onClick={() => {
            if (isMobile) sendEvent(...tracking);

            router.push(link);
          }}
        >
          <Icon className="dashboardAdditionalCategoryList-item-icon" />

          <h3 className="dashboardAdditionalCategoryList-item-title">
            {title}
          </h3>

          <p className="dashboardAdditionalCategoryList-item-description">
            {description}
          </p>
        </li>
      ))}
    </ul>
  );
}
